import(/* webpackMode: "eager" */ "/app/webapp/app/global-error.tsx");
